import Lenis from '@theme/lenis';

/**
 * @returns {boolean}
 */
function shouldEnableLenis() {
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return false;
  if (document.documentElement.classList.contains('shopify-design-mode')) return false;
  return true;
}

/**
 * @returns {number}
 */
function getAnchorOffset() {
  const headerHeight = getComputedStyle(document.documentElement).getPropertyValue('--header-height').trim();
  const parsed = parseFloat(headerHeight);
  return Number.isFinite(parsed) ? parsed : 0;
}

/**
 * @returns {boolean}
 */
function isScrollLocked() {
  return (
    document.documentElement.hasAttribute('scroll-lock') ||
    Boolean(document.querySelector('dialog[open]'))
  );
}

function markScrollContainers() {
  document.querySelectorAll('scroll-hint, dialog, [scroll-lock]').forEach((element) => {
    element.setAttribute('data-lenis-prevent', '');
  });
}

function initLenis() {
  if (!shouldEnableLenis()) return;

  markScrollContainers();

  const lenis = new Lenis({
    autoRaf: true,
    lerp: 0.1,
    wheelMultiplier: 1,
  });

  /** @type {Window & { lenis?: Lenis }} */
  const win = window;
  win.lenis = lenis;

  document.addEventListener('click', (event) => {
    const target = event.target;
    if (!(target instanceof Element)) return;

    const link = target.closest('a[href^="#"]');
    if (!(link instanceof HTMLAnchorElement)) return;

    const id = link.getAttribute('href');
    if (!id || id === '#') return;

    const anchor = document.querySelector(id);
    if (!(anchor instanceof HTMLElement)) return;

    event.preventDefault();
    lenis.scrollTo(anchor, { offset: -getAnchorOffset() });
  });

  const syncLenisState = () => {
    if (isScrollLocked()) {
      lenis.stop();
    } else {
      lenis.start();
    }
  };

  document.addEventListener('dialog:open', () => lenis.stop());
  document.addEventListener('dialog:close', () => {
    lenis.scrollTo(window.scrollY, { immediate: true });
    syncLenisState();
  });

  const scrollLockObserver = new MutationObserver(syncLenisState);
  scrollLockObserver.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ['scroll-lock'],
  });

  document.addEventListener(
    'shopify:section:load',
    () => {
      markScrollContainers();
      syncLenisState();
    },
    { passive: true }
  );
}

initLenis();
